// extracted by mini-css-extract-plugin
export default {"banner":"App_banner__8J9nM","ion_app":"App_ion_app__fps4b"};